import { Component } from '@angular/core';
import { GamesGroupService, IPollQuestion, PopulationQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-polls-page',
  templateUrl: './polls-page.component.html',
  styleUrl: './polls-page.component.scss',
})
export class PollsPageComponent {
  populations = Populations;
  pollsQuestion$: Observable<IPollQuestion[]>;
  isFreePopulation: boolean = false;

  constructor(
    private gamesGroupService: GamesGroupService,
    private populationQuery: PopulationQuery
  ) {}

  ngOnInit(): void {
    this.pollsQuestion$ = this.gamesGroupService.fetchPolls();
    this.isFreePopulation = this.populationQuery.userInPopulation([Populations.Free]);
  }
}
